<template>
  <div>
    <CompanyHeader :img_header="header_image" header="ตั้งค่าข้อมูลบริษัท" link_back="managewebsite"/>
    <MenuCompany/>
    <Company_information/>
  </div>
</template>

<script>
import CompanyHeader from "@/components/admin/manage_website/company_setting/menu_company/CompanyHeader";
import HeaderImage from "@/assets/process.png";
import MenuCompany from "@/components/admin/manage_website/company_setting/menu_company/MenuCompany";
import Company_information from "@/components/admin/manage_website/company_setting/Company_information";
export default {
  name: "CompanyInformation",
  components: {
    Company_information,
    MenuCompany,
    CompanyHeader
  },
  data() {
    return {
      header_image: HeaderImage
    }
  }
}
</script>

<style scoped>

</style>
